/**
 * @param {Array<T>} arr
 * @returns {Array<T>}
 */
export const distinct = arr => arr.filter((value, index, self) => self.indexOf(value) === index);
